import { Anchoring } from './Anchoring';
export default class AnchoringSecured extends Anchoring {
    constructor(anchor, freeText) {
        super(anchor, freeText);
    }
}
//# sourceMappingURL=AnchoringSecuredData.js.map